import React, { useEffect, useState } from 'react';
import '../../css/PostRequestForm.css';
import { useDispatch, useSelector } from 'react-redux';
import { RequestsActions } from '../../_store/Requests.slice';
import CustomModal from '../../components/common/CustomModal ';
import Button from '../../components/common/ui/Button';
import TextAreaInput from '../../components/common/ui/Inputs/TextAreaInput';
import CustomKeyboard from '../../components/common/CustomKeyboard';
import RequestFormInfoSchema from '../../validation/RequestFormInfoSchema';
import { memo } from 'react';
import { DocumentsActions } from '../../_store/document.slice';
import PdfViewer from '../../components/common/PdfViewer';
import Loader from '../../components/common/Loader';
import CustomTable from '../../components/common/CustomTable';
import sendmessage from '../../assets/images/send-message.svg';
import { KioskDashboardActions } from '../../_store';
import TranslateFile from '../../Loc/TranslateFile';
import { getStoredValue } from "../../_helpers/storageHelper";

const RequestFormInfo = ({ setisEdit, isShowinboxlist, isPdfdata, setisPdfdata, selectformcategory, handleBack, isEdit, selectrowItem }) => {
    const [description, setDescription] = useState('');
    const dispatch = useDispatch();
    const [issubmit, setissubmit] = React.useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [modalContent, setmodalContent] = useState("");
    const [modalContentColor, setmodalContentColor] = useState("");
    const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
    const [prevdescription, setprevdescription] = useState();
    const [ishandleSubmitRespond, setishandleSubmitRespond] = useState(false);
    const [errorMessage, setErrorMessage] = useState({});
    const [isLoading, setisLoading] = React.useState(false);
    const [PostList, setPostList] = useState([]);
    const [formInfo, setformInfo] = useState();
    const {
        Requests: {
            InmateRequestFormPermissionDetails,
            InmateRequestPublicDefenderThreadResponse,
            InmateRequestPublicDefenderThreadPostResponse,
            loadInmateRequestForumThreadResponse,
            InmateRequestForumThreadPostResponse,
            LoadInmateMGUserRequestForumThreadResponse,
            LoadInmateMGUserRequestForumThreadPostResponse
        },
        kioskLogin: { loginResponse, loginDetails }
    } = useSelector(state => state);
    const storedloginResponse = getStoredValue("loginResponse") || loginResponse;
    const storedLoginDetails = getStoredValue("loginDetails") || loginDetails;
    const selectValue = InmateRequestFormPermissionDetails?.find(x => x?.RequestFormTypeID === selectformcategory);
    const [resultFormTypeId, setresultFormTypeId] = useState();
    const currentLang = TranslateFile();


    const [formData, setFormData] = useState({
        title: '',
        fullname: '',
        createdDate: '',
        PostBody: '',
        postby: '',
        sendDate: '',
    })

    const fetchdata = () => {
        if (isShowinboxlist) {
            if (selectrowItem?.IsInmateReadStatus == 0) {
                var Objectdata = {
                    inmatesId: selectrowItem?.InmateID, facilityID: storedloginResponse?.facilityID, requestForumThreadID: selectrowItem?.RequestForumMGUserThreadID,
                    requestFormTypeID: selectrowItem?.RequestFormType,
                };
                dispatch(RequestsActions.LoadUpdateInmateMGUserRequestRead(Objectdata));
                var data = {
                    requestFormTypeID: 0, pageNo: 1, rowCountPerPage: 10,
                    facilityID: storedloginResponse?.facilityID, inmatesId: storedloginResponse?.InmateID,
                };
                dispatch(RequestsActions.getInmateMGUserRequestFormSearch(data));
                var apidata = {
                    inmatesId: storedloginResponse?.InmateID, facilityID: storedloginResponse?.facilityID,
                };
                dispatch(RequestsActions.LoadInmateMGUserRequestUnReadCount(apidata));
                const podCode = storedLoginDetails?.PodCode;
                const inmateID = storedloginResponse?.InmateID;
                if (inmateID && podCode)
                    dispatch(KioskDashboardActions.getLoadInmateMainMenu({ inmateID, podCode }));
            }
            setisLoading(true);
            dispatch(RequestsActions.LoadInmateMGUserRequestForumThread(selectrowItem?.RequestForumMGUserThreadID)).then(x => {
                setisLoading(false);
                if (x?.payload?.length > 0) {
                    setformInfo(x?.payload[0]);
                }
            })
            setisLoading(true);
            dispatch(RequestsActions.LoadInmateMGUserRequestForumThreadPost(selectrowItem?.RequestForumMGUserThreadID)).then(x => {
                setisLoading(false);
                if (x?.payload)
                    setPostList(x?.payload);
            }).then(x => {
                var Objectdata = {
                    inmatesId: storedloginResponse?.InmateID, facilityID: storedloginResponse?.facilityID,
                };
                dispatch(RequestsActions.LoadInmateMGUserRequestUnReadCount(Objectdata));
            })
        }
        else {
            const formReqAccess = resultFormTypeId || selectrowItem?.RequestFormTypeID;
            if (selectformcategory === 53) {
                setisLoading(true);
                dispatch(RequestsActions.loadInmateRequestPublicDefenderThread(formReqAccess)).then(x => {
                    setisLoading(false);
                    if (x?.payload?.length > 0) {
                        setformInfo(x?.payload[0])
                    }
                })
                setisLoading(true);
                dispatch(RequestsActions.loadInmateRequestPublicDefenderThreadPost(formReqAccess)).then(x => {
                    setisLoading(false);
                    if (x?.payload)
                        setPostList(x?.payload);
                })
            } else {
                setisLoading(true);
                dispatch(RequestsActions.loadInmateRequestForumThread({ formReqAccess, storedloginResponse })).then(x => {
                    setisLoading(false);
                    if (x?.payload?.length > 0) {
                        setformInfo(x?.payload[0])
                    }
                })
                setisLoading(true);
                dispatch(RequestsActions.loadInmateRequestForumThreadPost(formReqAccess)).then(x => {
                    setisLoading(false);
                    if (x?.payload)
                        setPostList(x?.payload);
                })

            }
        }

    }

    useEffect(() => {
        if (!isEdit) return;
        fetchdata();
    }, [isEdit]);

    useEffect(() => {
        if (isShowinboxlist && LoadInmateMGUserRequestForumThreadResponse?.length > 0 && LoadInmateMGUserRequestForumThreadPostResponse?.length > 0) {
            const [thread] = LoadInmateMGUserRequestForumThreadResponse;
            const [post] = LoadInmateMGUserRequestForumThreadPostResponse;
            setFormData({
                title: thread?.ForumThreadTitle,
                fullname: thread?.RequestCreateByName,
                createdDate: thread?.RequestCreateDate,
                PostBody: post?.ForumPostBody,
                postby: post?.ForumThreadPostBy,
                sendDate: post?.ReqPostSendDate,
            });
        }
    }, [
        isShowinboxlist,
        LoadInmateMGUserRequestForumThreadResponse,
        LoadInmateMGUserRequestForumThreadPostResponse,
    ]);

    useEffect(() => {
        const isPublicDefender = selectformcategory === 53;
        const publicDefenderThreadReady = InmateRequestPublicDefenderThreadResponse?.length > 0 && InmateRequestPublicDefenderThreadPostResponse?.length > 0;
        const forumThreadReady = loadInmateRequestForumThreadResponse?.length > 0 && InmateRequestForumThreadPostResponse?.length > 0;
        if (isPublicDefender && publicDefenderThreadReady) {
            const [thread] = InmateRequestPublicDefenderThreadResponse;
            const [post] = InmateRequestPublicDefenderThreadPostResponse;
            setFormData({
                title: thread?.ForumThreadTitle,
                fullname: thread?.IsCreatedByMuUser == 1 ? thread?.MuUserFullName : thread?.InmateFullName,
                createdDate: thread?.RequestCreateDate,
                PostBody: post?.ForumPostBody,
                postby: post?.ForumThreadPostBy,
                sendDate: post?.ReqPostSendDate,
            });
        } else if (forumThreadReady) {
            const [thread] = loadInmateRequestForumThreadResponse;
            const [post] = InmateRequestForumThreadPostResponse;
            setFormData({
                title: thread?.ForumThreadTitle,
                fullname: thread?.IsCreatedByMuUser == 1 ? thread?.MuUserFullName : thread?.InmateFullName,
                createdDate: thread?.RequestCreateDate,
                PostBody: post?.ForumPostBody,
                postby: post?.ForumThreadPostBy,
                sendDate: post?.ReqPostSendDate,
            });
        }
    }, [
        selectrowItem?.RequestFormType,
        InmateRequestPublicDefenderThreadPostResponse,
        InmateRequestPublicDefenderThreadResponse,
        loadInmateRequestForumThreadResponse,
        InmateRequestForumThreadPostResponse,
    ]);

    const handleDescriptionChange = (input) => {
        setDescription(input);
        setErrorMessage({ ...errorMessage, description: input?.trim()?.length > 0 ? "" : currentLang?.ValidationSchema?.Description_Required });
    };


    const handleSubmitRespond = (e) => {
        e.preventDefault();
        setErrorMessage({});

        if (ishandleSubmitRespond) return;

        const { error } = RequestFormInfoSchema({ description });
        if (error) {
            error.details.forEach((e) => {
                setErrorMessage((prev) => ({
                    ...prev,
                    [e.path.toString()]: e.message,
                }));
            });
            return;
        }
        if (selectrowItem?.RequestForumMGUserThreadID) {
            const data = {
                requestForumThreadID: selectrowItem?.RequestForumMGUserThreadID,
                facilityID: storedLoginDetails?.FacilityID,
                managementUserID: 0,
                postByMuUser: 0,
                postByInmate: 1,
                podCode: storedLoginDetails?.PodCode,
                pdFormPostBody: description,
                pdfAttachPath: "",
                postType: 0,
                activeStatus: 0
            };
            setisLoading(true);
            setishandleSubmitRespond(true);
            dispatch(RequestsActions.LoadRequestForumMGUserThreadRespond(data))
                .then(x => {
                    if (x?.payload) {
                        handleRespond(x?.payload);
                    }
                })
                .finally(() => {
                    setisLoading(false);
                    setishandleSubmitRespond(false);
                });

        } else if (selectformcategory === 53) {
            const apidata = {
                pRequestFormTypeID: InmateRequestPublicDefenderThreadResponse[0]?.RequestPublicDefenderThreadID || selectrowItem?.RequestFormTypeID,
                facilityID: storedLoginDetails?.FacilityID,
                inmatesId: storedloginResponse?.InmateID,
                managementUserID: 0,
                postByInmate: 1,
                postByMuUser: 0,
                activeStatus: 0,
                pdFormPostBody: description,
                pdfAttachPath: "",
                postType: 0,
            };
            setishandleSubmitRespond(true); setisLoading(true);
            dispatch(RequestsActions.LoadRequestPublicDefenderThreadRespond(apidata))
                .then(x => {
                    if (x?.payload) {
                        handleRespond(x?.payload);
                    }
                })
                .finally(() => {
                    setishandleSubmitRespond(false); setisLoading(false);
                });

        } else {
            const requestBody = {
                requestForumThreadID: loadInmateRequestForumThreadResponse[0]?.RequestForumThreadID || selectrowItem?.RequestFormTypeID,
                facilityID: storedLoginDetails?.FacilityID,
                inmatesId: storedloginResponse?.InmateID,
                managementUserID: 0,
                postByInmate: 1,
                postByMuUser: 0,
                activeStatus: 0,
                noticesTitle: description,
                pdfAttachPath: "",
                postType: 0,
            };
            setishandleSubmitRespond(true); setisLoading(true);
            dispatch(RequestsActions.LoadRequestForumThreadRespond(requestBody))
                .then(x => {
                    if (x?.payload) {
                        handleRespond(x?.payload);
                    }
                    const LakefacilityId = process.env.REACT_APP_AUTO_GENERATE_EMAIL_FACILITY_ID;
                    const DisciplinaryreqId = process.env.REACT_APP_AUTO_GENERATE_EMAIL_REQ_ID;
                    const FacilityID = storedLoginDetails?.FacilityID;

                    if (x?.payload > 0 && selectformcategory == DisciplinaryreqId && FacilityID == LakefacilityId) {
                        dispatch(RequestsActions.loadSendEmailToDisciplinaryReportAppeals({
                            facilityName: storedLoginDetails?.FacilityCode,
                            emailTo: process.env.REACT_APP_AUTO_GENERATE_EMAIL_TO,
                            inmateName: storedloginResponse?.InmateFullName,
                            inmateId: storedloginResponse?.InmatesResdId,
                            appealSubmissionDateTime: new Date().toLocaleString('en-US', {
                                timeZone: 'America/New_York'
                            }),
                        }))
                    }
                })
                .finally(() => {
                    setishandleSubmitRespond(false); setisLoading(false);
                });
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setErrorMessage({});
        const { error } = RequestFormInfoSchema({ description });
        if (error) {
            error.details.forEach((e) => {
                setErrorMessage((prev) => ({
                    ...prev,
                    [e.path.toString()]: e.message,
                }));
            });
            return;
        }
        if (selectformcategory == 53) {
            var Objectdata = {
                pRequestFormTypeID: selectformcategory, podCode: storedLoginDetails?.PodCode, pdFormPostBody: description,
                pdFormThreadTitle: selectValue?.RequestFormType, facilityID: storedloginResponse?.facilityID, inmatesId: storedloginResponse?.InmateID,
            };
            dispatch(RequestsActions.loadRequestPublicDefenderThreadInsert(Objectdata)).then(x => {
                if (x?.payload)
                    handleModalContent(x?.payload, currentLang?.AlertPopup?.Request_Submit_Success, currentLang?.AlertPopup?.Subject_Already_Exists);
            });
        }
        else {
            var Objectdata = {
                formReqAccess: selectformcategory, podCode: storedLoginDetails?.PodCode, messageKeyword: description,
                noticesTitle: selectValue?.RequestFormType, facilityID: storedloginResponse?.facilityID, inmatesId: storedloginResponse?.InmateID,
            };

            dispatch(RequestsActions.loadRequestForumThreadInsert(Objectdata)).then(x => {
                if (x?.payload) {
                    handleModalContent(x?.payload, currentLang?.AlertPopup?.Request_Submit_Success, currentLang?.AlertPopup?.Subject_Already_Exists);
                }
                const LakefacilityId = process.env.REACT_APP_AUTO_GENERATE_EMAIL_FACILITY_ID;
                const DisciplinaryreqId = process.env.REACT_APP_AUTO_GENERATE_EMAIL_REQ_ID;
                const FacilityID = storedLoginDetails?.FacilityID;

                if (x?.payload > 0 && selectformcategory == DisciplinaryreqId && FacilityID == LakefacilityId) {
                    handleSendEmail();
                }
            });
        }
        setissubmit(true)

    };

    // Common function to handle modal content and color
    const handleModalContent = (response, successMessage, errorMessage) => {
        if (response > 0) {
            setresultFormTypeId(response);
            setmodalContent(successMessage);
            setmodalContentColor('#4a9a93');
        } else {
            setmodalContent(errorMessage);
            setmodalContentColor('#c8605e');
        }
        setShowPopup(true);
    };

    const handleSendEmail = () => {
        dispatch(RequestsActions.loadSendEmailToDisciplinaryReportAppeals({
            facilityName: storedLoginDetails?.FacilityCode,
            emailTo: process.env.REACT_APP_AUTO_GENERATE_EMAIL_TO,
            inmateName: storedloginResponse?.InmateFullName,
            inmateId: storedloginResponse?.InmatesResdId,
            appealSubmissionDateTime: new Date().toLocaleString('en-US', {
                timeZone: 'America/New_York'
            }),
        }))
    }

    const handleRespond = (value) => {
        switch (value) {
            case 1:
                fetchdata();
                setmodalContent(currentLang?.AlertPopup?.Request_Submit_Success);
                setShowPopup(true); setmodalContentColor('#4a9a93');
                break;
            case -1:
                setmodalContent(currentLang?.AlertPopup?.Operation_Failed);
                setShowPopup(true); setmodalContentColor('#c8605e');
                break;
            case -2:
                setmodalContent(currentLang?.AlertPopup?.Not_Exist_This_Thread); setmodalContentColor('#c8605e');
                setShowPopup(true)
                break;
            case -3:
                setmodalContent(currentLang?.AlertPopup?.Not_Valid_Admin); setmodalContentColor('#c8605e');
                setShowPopup(true)
                break;
            case -4:
                setmodalContent(currentLang?.AlertPopup?.File_Empty); setmodalContentColor('#c8605e');
                setShowPopup(true)
                break;
        }
    }
    function separatePathAndFileName(filePath) {
        // Find the last index of the '/' character
        const lastSlashIndex = filePath.lastIndexOf('/');

        // Extract folder path and file name

        let folderPath = filePath.substring(0, lastSlashIndex + 1);
        if (process.env.REACT_APP_FOLDER_PATH && process.env.REACT_APP_FOLDER_PATH.trim() !== "") {
            folderPath = `${process.env.REACT_APP_FOLDER_PATH}${filePath.substring(0, lastSlashIndex + 1)}`;
        }

        var filename = filePath.substring(lastSlashIndex + 1);

        return { folderPath, filename };
    }


    const handlepdfView = (value) => {
        setisLoading(true);
        const { folderPath, filename } = separatePathAndFileName(value?.PdfDocAttachPath);
        dispatch(DocumentsActions.getDownloadFileFromPath({ folderPath, filename })).then(x => {
            if (x?.payload) setisPdfdata(x?.payload); setisLoading(false);
        })
    }

    const handleKeyPress = (button) => {
        if (button === "{accept}" || button === "{enter}" || button === "{prev}" || button === "{next}" || button === "{cancel}") {
            setIsKeyboardOpen(false);
        }
        else if (button === "{backspace}") {
            setDescription(description?.slice(0, -1));
        }
    };

    const columns = [
        {
            name: currentLang?.TableHeaders?.Request, selector: (row) => row.ForumPostBody,
            cell: (row) => (
                row?.PostByInmate === 1 ? (
                    <div className="d-flex align-items-center">
                        <span><img src={sendmessage} className='width-small-img'></img></span>
                        <div className="request-text pre-wrap-text" dangerouslySetInnerHTML={{ __html: row?.ForumPostBody }} />
                    </div>
                ) : (
                    <div className="d-flex flex-column align-items-start">
                        {row?.IsAttachDocPDF === 1 && (<div className="d-flex align-items-center gap-2">
                            <a
                                className="status-patch-primary btn btn-primary btn-small"
                                onClick={() => {
                                    handlepdfView(row);
                                }}
                            >
                                {currentLang?.Requests?.View_PDF}
                            </a>

                        </div>)}
                        <div className="pre-wrap-text" dangerouslySetInnerHTML={{ __html: row?.ForumPostBody }} />
                    </div>
                )
            )

        },
        { name: currentLang?.TableHeaders?.Posted_By, selector: (row) => row.ForumThreadPostBy },
        { name: currentLang?.TableHeaders?.Sent_On, selector: (row) => row.ReqPostSendDate },
    ];

    return (
        <>
            {isLoading && <Loader />}
            {isPdfdata ? <PdfViewer base64={isPdfdata} /> :
                <>
                    {!isEdit ? <div className='card'>
                        <div className="panel panel-default">
                            <div className="panel-heading">{currentLang?.Requests?.Post_Request}</div>
                            <div className="panel-body" >
                                {/* <h3>{selectValue?.FacilityRequestFormTitle}</h3> */}
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <TextAreaInput
                                            name="description"
                                            id="Description"
                                            label={selectValue?.FacilityRequestFormTitle?.replace("( New )", "")}
                                            value={description}
                                            onClick={() => { setIsKeyboardOpen(true); setprevdescription(description) }}
                                            handleChange={handleDescriptionChange}
                                            placeholder={currentLang?.Requests?.Description_Placeholder}
                                            rows={4}
                                            errorMessage={errorMessage}
                                            maxCharacter={selectValue?.RequestFormTypeID == 61 ? 200 : 2000}
                                        />
                                    </div>
                                    <div className="d-flex justify-content-end gap-3 mt-30">
                                        <Button label={currentLang?.Buttons?.Submit} status="primary" type="submit" isLoading={issubmit} disabled={issubmit} />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                        :
                        <>
                            <div className="panel panel-default">
                                <h2 className='panel-heading'>{currentLang?.Requests?.Request_Information}</h2>
                                <div className='panel-body'>
                                    <div className="message-container">
                                        <div className="form-grid mb-2">
                                            <div className="grid-item">
                                                <p className='mb-0 text-gray'>{currentLang?.Requests?.Title}</p>
                                                <p className="bold-text text-default-red mb-0" >{formData?.title}</p>
                                            </div>
                                            <div className="grid-item">
                                                <p className='mb-0 text-gray'>{currentLang?.Requests?.Created_By}</p>
                                                <p className="bold-text text-default-red mb-0" >{formData?.fullname}</p>
                                            </div>
                                            <div className="grid-item">
                                                <p className='mb-0 text-gray'>{currentLang?.Requests?.Created_Date}</p>
                                                <p className="bold-text text-default-red mb-0" >{formData?.createdDate}</p>
                                            </div>
                                        </div>
                                    </div>
                                    {(formInfo?.IsInmateLastReply == 0 && formInfo?.ReqCurrentStatus == 1) ? <div>
                                        <form className='mb-2'>
                                            <div className="form-group">
                                                <TextAreaInput
                                                    name="description"
                                                    id="Description"
                                                    label={currentLang?.Requests?.Description}
                                                    value={description}
                                                    onClick={() => { setIsKeyboardOpen(true); setprevdescription(description) }}
                                                    handleChange={handleDescriptionChange}
                                                    placeholder={currentLang?.Requests?.Description_Placeholder}
                                                    rows={4}
                                                    errorMessage={errorMessage}
                                                />
                                            </div>
                                            <div className="d-flex justify-content-end gap-3 mt-30">
                                                <Button label={currentLang?.Buttons?.Submit} onClick={handleSubmitRespond} status="success" type="submit" isLoading={ishandleSubmitRespond} disabled={issubmit} />
                                            </div></form>
                                    </div>
                                        : formInfo?.RequestCurrentStatus !== "Closed" ? <p className="textnote">
                                            {currentLang?.Requests?.Request_Note}
                                        </p> : <></>}

                                    <CustomTable columns={columns} data={PostList} pagination={false}
                                        paginationPerPage={100}
                                        totalRowCount={PostList?.length}
                                    />

                                </div></div>
                        </>
                    }

                    {isKeyboardOpen && (
                        <div className="card-default">
                            <CustomKeyboard
                                onInputChange={handleDescriptionChange}
                                inputValue={description}
                                onKeyPress={handleKeyPress}
                                setShowBoard={setIsKeyboardOpen}
                                placeholder={currentLang?.Requests?.Description_Placeholder}
                                handleCancel={() => { setDescription(prevdescription); setIsKeyboardOpen(false) }}
                                isTabfunction={true}
                                isEnterfunction={true}
                                maxCharacter={selectValue?.RequestFormTypeID == 61 ? 200 : 2000}
                            />
                        </div>
                    )}
                    {showPopup && (
                        <CustomModal
                            color={modalContentColor}
                            content={modalContent}
                            onOkClick={() => {
                                // if (isEdit) {
                                //     handleBack();
                                // } else {
                                setisEdit(true);
                                setShowPopup(false);
                                setDescription('');
                                setissubmit(false);
                                setishandleSubmitRespond(false);

                                // }
                            }}
                        />
                    )}
                </>
            }
        </>
    );
};

export default memo(RequestFormInfo);
